import React from 'react';

/**
 * GeoPattern component - adds geometric pattern overlay
 */
const GeoPattern: React.FC = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-30 z-0">
    <div className="absolute top-0 left-1/4 w-[800px] h-[800px] border border-[#854C73] rounded-full opacity-20 translate-y-[-50%] animate-pulse-slow"></div>
    <div className="absolute top-0 right-1/4 w-[800px] h-[800px] border border-[#854C73] rounded-full opacity-20 translate-y-[-50%] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
    <div className="absolute top-[20%] left-1/2 w-[1px] h-full bg-[#854C73] opacity-10"></div>
  </div>
);

export default GeoPattern;

